import { useState } from "react";
import { Link } from "react-router-dom";
import Hint from "./Hint";

const KEY = "kpi.concept.collapsed";

type Step = { no: string; term: string; titel: string; text: string; to: string };

const STEPS: Step[] = [
  { no: "1", term: "mandant", titel: "Mandant", text: "Ihr eigener, abgeschotteter Datenraum.", to: "/app/company" },
  { no: "2", term: "quelle", titel: "Quellen", text: "Systeme, aus denen Werte und Belege kommen.", to: "/app/sources" },
  { no: "3", term: "trust_gate", titel: "Trust-Gate", text: "Qualitätsschranke: erst prüfen, dann anzeigen.", to: "/app/sources" },
  { no: "4", term: "kpi", titel: "Kennzahlen", text: "Ist-Wert, Ziel und Zielerreichung je KPI.", to: "/app/metrics" },
  { no: "5", term: "driver_tree", titel: "Driver-Tree", text: "Welcher Hebel wirkt auf welche Kennzahl?", to: "/app/trees" },
  { no: "6", term: "briefing", titel: "Briefing", text: "Management-Bericht aus genau diesen Daten.", to: "/app/briefings" },
];

/**
 * "So hängt alles zusammen" - der rote Faden der App, in einer Zeile.
 * Einklappbar; der Zustand wird lokal gemerkt.
 */
export function ConceptFlow({ compact = false }: { compact?: boolean }) {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try { return window.localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  const toggle = () => {
    setCollapsed((v) => {
      const next = !v;
      try { window.localStorage.setItem(KEY, next ? "1" : "0"); } catch { /* egal */ }
      return next;
    });
  };

  return (
    <section className={`concept-flow ${collapsed ? "is-collapsed" : ""}`} aria-label="So hängt alles zusammen">
      <div className="concept-head">
        <div>
          <p className="hero-eyebrow">Orientierung</p>
          <h2>So hängt alles zusammen</h2>
          {!collapsed && (
            <p className="muted small">
              Von links nach rechts: Ohne vertrauenswürdige Quellen keine Kennzahlen - ohne Kennzahlen kein
              Treiberbaum - ohne Treiberbaum kein belastbares Briefing. Jeder Schritt ist anklickbar.
            </p>
          )}
        </div>
        <div className="concept-head-actions">
          <Link to="/app/hilfe" className="btn ghost small">Ausfuehrlich erklärt</Link>
          <button className="btn ghost small" onClick={toggle} aria-expanded={!collapsed}>
            {collapsed ? "Einblenden" : "Ausblenden"}
          </button>
        </div>
      </div>

      {!collapsed && (
        <ol className={`concept-steps ${compact ? "compact" : ""}`}>
          {STEPS.map((s, i) => (
            <li key={s.no}>
              <Link to={s.to} className="concept-step">
                <span className="concept-no">{s.no}</span>
                <strong>
                  {s.titel}
                  <Hint term={s.term} />
                </strong>
                <p>{s.text}</p>
              </Link>
              {i < STEPS.length - 1 && <span className="concept-arrow" aria-hidden="true">-&gt;</span>}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

export default ConceptFlow;
